import React from 'react';
import { useNavigate } from 'react-router-dom';
import { KnowledgeSprint } from '../components/KnowledgeSprint';

export const KnowledgeSprintPage = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/');
  };

  return (
    <div className="bg-white text-black dark:bg-gray-800 dark:text-white">
      <KnowledgeSprint onClose={handleClose} />
    </div>
  );
};